import styled, { css } from 'styled-components';
import { device } from 'modules/Utils/Devices';
import { ZIndexes } from 'modules/Utils/ZIndexes';

const Header = styled.header`
  position: sticky;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 320px;
  top: 0;
  right: 0;
  left: 0;
  z-index: ${ZIndexes.header + 3};

  /* Desktop/Tablet: original light header */
  ${(props) =>
    !props.$isMobile &&
    css`
      height: 8rem;
      background-color: ${(props) => props.theme.config.colors.light};
      box-shadow: 0px 4px 4px
        ${(props) =>
          !props.noShadow ? 'rgba(0, 0, 0, 0.08)' : 'rgba(0, 0, 0, 0)'};
    `}

  /* Mobile: new dark header */
  ${(props) =>
    props.$isMobile &&
    css`
      height: 8rem;
      padding: 0 2.4rem;
      z-index: ${ZIndexes.header + 5};
      background-color: ${(props) => props.theme.config.colors.secondary_800};
      border-bottom: 1px solid
        ${(props) => props.theme.config.colors.secondary_700};
      box-shadow: ${(props) =>
        !props.noShadow ? '0px 4px 4px rgba(0, 0, 0, 0.08)' : 'none'};
    `}
`;

/* Desktop/Tablet: original layout */
const MenuContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${(props) => props.theme.config.spacing.layout_6};
  width: 7.2rem;
  border-right: 0.1rem;
  border-right-color: ${(props) => props.theme.config.colors.gray_300};
  border-right-style: solid;
  opacity: 0.25;
  transition: 0.2s ease-in;

  ${({ opened }) =>
    opened &&
    css`
      margin-left: 34rem;
      transition: 0.2s ease-out;

      @media ${device.tablet} {
        margin-left: ${(props) => props.theme.config.spacing.layout_2};
      }
    `}

  @media ${device.tablet} {
    margin-left: ${(props) => props.theme.config.spacing.layout_2};
  }

  i.edu-icon-menu {
    ${(props) => props.theme.config.typograph.default};
    position: relative;
    left: -0.3rem;
  }
`;

const WhitelabelContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${(props) => props.theme.config.spacing.layout_3};

  @media ${device.tablet} {
    margin-left: ${(props) => props.theme.config.spacing.layout_2};
  }

  span {
    color: ${(props) => props.theme.config.colors.text_base};
  }

  strong {
    color: ${(props) => props.theme.config.colors.primary};
    font-weight: 700;
  }
`;

const DesktopRightContainer = styled.div`
  margin: 0 1.6rem 0 auto;
  display: flex;
  align-items: center;
`;

/* Mobile: new layout */
const MobileLogoWhitelabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  min-width: 0;
`;

const MobileLogoWrapper = styled.a`
  width: 4.2rem;
  height: 4.2rem;
  flex-shrink: 0;
  border-radius: 8px;
  background-color: ${(props) => props.theme.config.colors.primary_600};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-decoration: none;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

const MobileWhitelabelText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  justify-content: center;
`;

const MobileYouAreIn = styled.span`
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.config.colors.light};
  font-weight: 400;
`;

const MobileWhitelabelName = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.config.colors.primary};
`;

const MobileRightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  position: relative;
`;

const AvatarWrapper = styled.div`
  width: 4.2rem;
  height: 4.2rem;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
`;

const HamburgerButton = styled.button`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background-color: ${(props) => props.theme.config.colors.primary_800};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.config.colors.primary_100};
  padding: 0;

  &:hover {
    opacity: 0.9;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export {
  Header,
  MenuContainer,
  WhitelabelContainer,
  DesktopRightContainer,
  MobileLogoWhitelabelWrapper,
  MobileLogoWrapper,
  MobileWhitelabelText,
  MobileYouAreIn,
  MobileWhitelabelName,
  MobileRightContainer,
  AvatarWrapper,
  HamburgerButton,
};
